module.exports = __webpack_public_path__ + "src/assets/img/01.496ea315.png";